var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"columns":_vm.columns,"data":_vm.getStockGlobalReports.data,"total":_vm.getStockGlobalReports.meta.page.total,"per-page":_vm.page.size,"current-page":_vm.page.number,"empty-message":"Laporan Stok Global Kosong"},on:{"pagechanged":_vm.handleChangePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }